/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { fbdbTime } from 'src/app/plain-javascript/background-scripts/fbdb-time';
import * as DefaultTickets from '../app-data/models/DefaultTicketData';
import { CONSTRAINT_ACCEPTANCE_STATE } from '@touchplan/common';

// design add workflow
// - extremely high odds we'll want to customize the ticket data before writing it, so seperate generating the initial data and actually writing it per the standard
// - get set of initial valid data via a type specific function that outputs the minimum required data
// - apply the necessary context specific data (positioning, dates, etc)
// - apply date math code against it
// - OPTIONAL, apply currently non-existance "fbdb precalc" data against it so it's initial data roughly matches what it will be after the first fbdb update
// - then write it

@Injectable()
export class TicketCreatorService {
	constructor() {}

	private dynamicDefaults() {
		return { createdAt: fbdbTime.syncTime };
	}

	public getDefaultTask(roleId: string, creatorId: string) {
		return Object.assign({}, DefaultTickets.defaultTaskData, this.dynamicDefaults(), { roleId, creatorId });
	}
	public getDefaultConstraint(
		requestedByProjectMemberId: string,
		requestedByProjectMemberRoleId: string,
		creatorId: string
	) {
		// MOC-3992
		// let assignedProjectMemberId: string = requestedByProjectMemberId;
		// let assignedProjectMemberRoleId: string  = requestedByProjectMemberRoleId;
		return Object.assign({}, DefaultTickets.defaultConstraintData, this.dynamicDefaults(), {
			requestedByProjectMemberId,
			requestedByProjectMemberRoleId,
			creatorId,
		});
	}
	public getDefaultMilestone(roleId: string, creatorId: string) {
		return Object.assign({}, DefaultTickets.defaultMilestoneData, this.dynamicDefaults(), {
			roleId,
			creatorId,
		});
	}
}
